import { useDisplayCurrency } from '../currency/DisplayCurrencyProvider';
import { formatAmountLabel } from './formatUtils';
import React from 'react';
import { TILE_LABEL_CLASS, tileClass } from '@charitystack/shared';

function StandardAmountButtons({
  amount,
  setAmount,
  defaultAmounts,
  elementID,
  brandColors,
  hasError,
  onAmountChange,
  onButtonSelect, // Signal that a preset button was clicked (clears custom input display)
  isButtonSelection = true, // false when user is typing in custom input (deselects all buttons)
  formDisplayMode = 'dynamic',
}) {
  const ctx = useDisplayCurrency();
  const formatAmountWithCommas = (value) => {
    const numeric = typeof value === 'number' ? value : Number(value);
    if (Number.isNaN(numeric)) return value;
    return numeric.toLocaleString('en-US');
  };
  // Donor redesign (CON-516, SPEC §C selected tile): the preset amounts are
  // amount CHIPS — one tile recipe. The selected fill is the brand TINT role the
  // provider writes on the scope, so `brandColors` no longer paints here.
  void brandColors;

  // Ensure we always have 4 button slots, filling missing ones with empty strings
  const buttonAmounts = Array(4)
    .fill('')
    .map((_, index) => defaultAmounts[index] || '');

  return (
    <div
      className={`standard-amount-buttons-grid grid grid-cols-2 gap-3 w-full transition-all duration-[var(--cs-motion-base)] ease-out ${
        hasError ? 'border border-[color:var(--cs-error-color)] rounded-[var(--cs-control-radius)]' : ''
      }`}
      id={`${elementID}-amount-buttons`}
    >
      {buttonAmounts.map((defaultAmount, i) => {
        const isSelected = isButtonSelection && amount === defaultAmount && defaultAmount !== '';
        const isDisabled = defaultAmount === '';
        // A preset amount is an amount chip (SPEC §C, Paper 66D-0 "Amount
        // tile"): 48 tall, radius 12, white with a 1px edge at rest, hover =
        // strong edge + subtle fill, pressed = sunken; selected = 2px accent
        // edge on the brand tint with no hover change. The rest arm still reads
        // --cs-control-shadow (it resolves to none) so the conformance gate's
        // control-cta family keeps proving the chips read their dials.
        return (
          <button
            key={i}
            type="button"
            className={`dynamic-button-text flex h-[var(--cs-size-control)] flex-1 items-center justify-center gap-2 px-5 ${TILE_LABEL_CLASS} ${tileClass(isSelected)}`}
            onClick={(e) => {
              if (defaultAmount !== '') {
                setAmount(e.target.value);
                if (onButtonSelect) onButtonSelect();
                if (onAmountChange) onAmountChange();
              }
            }}
            value={defaultAmount}
            disabled={isDisabled}
            id={`${elementID}-amount-button-${i}`}
          >
            {defaultAmount !== '' ? formatAmountLabel(defaultAmount, ctx, v => `$${formatAmountWithCommas(v)}`) : ''}
          </button>
        );
      })}
    </div>
  );
}

export default StandardAmountButtons;
